module.exports = "/images/icon_32_bookingprocessorange.png?723acb51c1f18ea2cd7e1236e0e6b25c";